import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutOmniWealth from "./sections/AboutOmniWealth";
import OurServices from "./sections/OurServices";
import HowWeWork from "./sections/HowWeWork";
import ClientTestimonials from "./sections/ClientTestimonials";
import ContactConsultation from "./sections/ContactConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutOmniWealth />
      <OurServices />
      <HowWeWork />
      <ClientTestimonials />
      <ContactConsultation />
      <Footer />
    </div>;
}